import {createApp} from 'vue'
import FormStafetSelector from './FormStafetSelector.options'

const el = '.kb-component--form-stafet-selector'

export default function(Store){
    const DOM = document.querySelectorAll(el)
        if (DOM.length) {
            DOM.forEach((FormStafetSelectorDOM) => {
                const props = {
                    elementName: FormStafetSelectorDOM.dataset.elementName,
                    elementId: FormStafetSelectorDOM.dataset.elementId,
                    fieldNames: JSON.parse(FormStafetSelectorDOM.dataset.fieldNames),
                    labels: JSON.parse(FormStafetSelectorDOM.dataset.labels)
                }
                const component = createApp(FormStafetSelector, props).use(Store)
                component.mount(FormStafetSelectorDOM)
            })
        }
}